import {SMART_RECOMMENDATION_ACTIONS} from '../../actions/smartRecommendationAction';

const smartRecommendationReducer = (state = {
  data : null,
}, action) => {
    switch (action.type) {
      case SMART_RECOMMENDATION_ACTIONS.FETCH_SMART_RECOMMENDATION_SUCCESS:{
        if(action.payload.length){
            return{
              ...state,
              data:  {
                recoMeta : action.payload[0].recommendationsMetaData,
                recoInsight: action.payload[0].insight
            }
          }   
      }        
    }
    default : {
      break;
    }
  }
    return state;
  }

  
  export default smartRecommendationReducer;